/**
 * Trimble-managed Features Service layers (vs user-authored map layers).
 * Point clouds use metadata.featureType === 'pointcloud' and the layer id below.
 * Breakline/PCI backend ids are TBD.
 */
export enum SystemLayerKind {
  PointCloud = 'pointCloud',
  Breakline = 'breakline',
  PciObject = 'pciObject',
}

export interface SystemLayer {
  readonly kind: SystemLayerKind;
  /** Maps API common_layerId. Empty when not yet known. */
  readonly layerId: string;
  readonly name: string;
  /** Internal/log-only for now — no consumer renders this yet, so it isn't localized. Revisit (translate or drop) once something displays it. */
  readonly description: string;
}

export const POINT_CLOUD_FEATURE_TYPE = 'pointcloud';

export const SYSTEM_LAYERS: readonly SystemLayer[] = [
  {
    kind: SystemLayerKind.PointCloud,
    layerId: 'QQrLmjOjRoY',
    name: 'Point Clouds',
    description:
      'Point cloud features generated by Trimble; carry the point cloud CRS used for coordinate conversions.',
  },
  {
    kind: SystemLayerKind.Breakline,
    // TODO(MERCATOR): confirm breakline system layer id with backend.
    layerId: '',
    name: 'Breaklines',
    description: 'Breakline features extracted by Trimble pipelines.',
  },
  {
    kind: SystemLayerKind.PciObject,
    // TODO(MERCATOR): confirm PCI system layer id with backend.
    layerId: '',
    name: 'PCI Objects',
    description:
      'Pavement Condition Index objects extracted by Trimble pipelines.',
  },
];

const SYSTEM_LAYER_IDS = new Set<string>(
  SYSTEM_LAYERS.map((layer) => layer.layerId).filter((id) => id.length > 0)
);

export function isSystemLayerId(layerId: string | undefined): boolean {
  return layerId !== undefined && SYSTEM_LAYER_IDS.has(layerId);
}

export function getSystemLayer(kind: SystemLayerKind): SystemLayer | undefined {
  return SYSTEM_LAYERS.find((layer) => layer.kind === kind);
}

/** Breakline layer id is not stable across projects — match by name. */
export function isBreaklineLayerName(name: string | undefined): boolean {
  return (name ?? '').trim().toLowerCase().includes('breakline');
}
